import type { Sparte } from '@/features/Global/types';
import type { STEP } from '@/router/steps';

export enum LOGGER_MODULE {
  GENERIC = 'generic',
  CONTRACT = 'contract',
  CLIENT = 'client',
  PROFILE = 'profile',
  QUOTE = 'quote',
  QUOTE_DOCUMENTS = 'quote documents',
  INVENTORY_CONTRACT = 'inventory contract',
  WEBREPORTS = 'webreports',
  TARIFF = 'tariff',
  COMPARISON = 'comparison',
  DISTRIBUTION = 'distribution',
  CONTRACT_DOCUMENTS = 'contract documents',
  AXIOS = 'axios',
  USER_SETTINGS = 'user settings',
  WKZ_SELECTION = 'wkz selection',
  INPUT_MAPPING = 'input mapping',
  VALIDATION = 'validation',
  AI = 'ai',
  VERSICHERUNGSANGABEN = 'versicherungsangaben',
}

export enum LOG_LEVEL_NAME {
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  NOTICE = 'NOTICE',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  CRITICAL = 'CRITICAL',
  ALERT = 'ALERT',
  EMERGENCY = 'EMERGENCY',
}

export type LogLevel = 7 | 6 | 5 | 4 | 3 | 2 | 1 | 0;

// see https://demvsystems.atlassian.net/wiki/spaces/RFD/pages/1756725263/RFD+5+Loggingkonventionen
export const LogLevelMapping: {
  [key in LOG_LEVEL_NAME]: LogLevel;
} = {
  [LOG_LEVEL_NAME.DEBUG]: 7,
  [LOG_LEVEL_NAME.INFO]: 6,
  [LOG_LEVEL_NAME.NOTICE]: 5,
  [LOG_LEVEL_NAME.WARNING]: 4,
  [LOG_LEVEL_NAME.ERROR]: 3,
  [LOG_LEVEL_NAME.CRITICAL]: 2,
  [LOG_LEVEL_NAME.ALERT]: 1,
  [LOG_LEVEL_NAME.EMERGENCY]: 0,
};

export interface LoggerContext {
  sparte?: Sparte;
  brokerId?: number;
  sentryId?: string;
  berechnungsId?: string;
  step?: STEP;
  bedarfId?: string;
}

export enum LOGGER_TRANSPORT {
  CONSOLE = 'consoleHandler',
  LOKI = 'lokiHandler',
}

export interface LogMessage {
  ts: number;
  context: LoggerContext;
  message: string;
  level: LogLevel;
  levelName: LOG_LEVEL_NAME;
  module: LOGGER_MODULE;
}

export interface LoggerTransport {
  handle: (message: LogMessage) => void;
}
